import React, { useRef, useState } from "react";
import { formatDate2, formatFileName } from "../../../../utils/dateFormats";
import { IAnalysisFolder } from "./IAnalysisFolder";
import "./FullAnalysisFolder.css";
import { getFolderIconByIndex } from "../../../../utils/folderIcons";

interface IFullAnalysisFolder{
    folder: IAnalysisFolder,
    className: string,
    onSelect:()=>void,
    onRename: (newName:string)=>void,
    onDelete:(item: IAnalysisFolder)=>void,
    onSettings?: (item: IAnalysisFolder)=>void
}

export const FullAnalysisFolder = ({folder, className, onSelect, onRename, onDelete, onSettings}: IFullAnalysisFolder)=>{
    const [editName, setEditName] = useState('');
    const [editMode, setEditMode] = useState(false);
    const editNameRef = useRef<HTMLInputElement>(null);

    const submitRename = ()=>{
        onRename(editName);
        setEditMode(false);
        //folder.name = editName;
    }

    return <div className={`button FullAnalysis_folder ${className}`} onClick={onSelect}>
        <div className="FullAnalysis_folder_sideMenu">
            <div className="button FullAnalysis_folder_sideMenu_button FullAnalysis_folder_sideMenu_button--more" onClick={(e)=>{
                e.stopPropagation();
                onSettings(folder);
            }}>
                More
            </div>
            <div className="button FullAnalysis_folder_sideMenu_button FullAnalysis_folder_sideMenu_button--edit" onClick={(e)=>{
                e.stopPropagation();
                setEditMode(true);
                setEditName(folder.name);
                requestAnimationFrame(()=>{
                  editNameRef.current?.focus();
                })

            }}>
                Edit
            </div>
            <div className="button FullAnalysis_folder_sideMenu_button FullAnalysis_folder_sideMenu_button--delete" onClick={(e)=>{
                e.stopPropagation();
                onDelete(folder);
            }}>
                Delete
            </div>
        </div>
        <div className="FullAnalysis_folder_icon" style={{backgroundImage: `url(${getFolderIconByIndex(folder.iconIndex || 0)})`}}>
            {folder.type === 'file' && <div className="FullAnalysis_folder__fileIndicator">📄</div>}
        </div>
        <div className="FullAnalysis_folder_info">
            <div ref={editNameRef} className="FullAnalysis_folder_name" onClick={(e)=>{
                e.stopPropagation();
                if (!editMode){
                    setEditMode(true);
                    setEditName(folder.name);
                    requestAnimationFrame(()=>{
                        editNameRef.current?.focus();
                      })
                }
            }}>
                {editMode ? <form onSubmit={()=>{submitRename()}}>
                    <input ref={editNameRef} value={editName}
                        onBlur={()=>submitRename()}
                        onChange={(e)=>setEditName(e.target.value)}
                    />
                </form> : formatFileName(folder.name)}
            </div>
            <div className="FullAnalysis_folder_date">
                {formatDate2(folder.date)}
            </div>
        </div>
    </div>
}